<ng-container [formGroup]="editService.formGroup">
    <wbo-single-select-edit-control [(ngModel)]="model.data['summary']"
                                    [label]="'wbo.report.edit.field.summary.label'"
                                    [placeholder]="'wbo.report.edit.field.summary.placeholder'"
                                    [allowClearSelectionOption]="false"
                                    [formControlName]="'summary'">
        <wbo-select-options>
            <wbo-select-option [value]="true" label="wbo.report.option.display.summary"></wbo-select-option>
            <wbo-select-option [value]="false" label="wbo.report.option.display.detailed"></wbo-select-option>
        </wbo-select-options>
    </wbo-single-select-edit-control>
</ng-container>
